import React, { useEffect, useRef, useState } from 'react';
import { connect, PromiseState } from 'react-refetch';

import useOnClickOutside from 'hooks/useOnClickOutside';

import Box from 'components/elements/Box';
import Span from 'components/elements/span';

import { IEntity } from 'components/search/ResultsSection/ResultsList/ResultsList';

import { GreenButton } from '../../styles';

import colors from 'styles/themes/colors';
import SearchDropdown from './SearchDropdown';
import { ICustomer } from 'redux/reducers/customers';

type PropsType = {
  isSmallScreen: boolean;
  addedPlaylists: string[];
  addPlaylistToUserList: (playlistId: string) => void;
  searchPlaylists: any;
  foundPlaylists: PromiseState<IEntity[]>;
  isSeparate?: boolean;
  customers: ICustomer[];
  addingPlaylist?: string;
  removingPlaylist?: string;
  deletePlaylist: (playlistId: string) => void;
};

const Search: React.FC<PropsType> = ({
  isSmallScreen,
  addedPlaylists,
  addPlaylistToUserList,
  foundPlaylists = PromiseState.create(),
  searchPlaylists,
  isSeparate = true,
  customers,
  addingPlaylist,
  removingPlaylist,
  deletePlaylist,
}) => {
  const [isOpenSearchDropdown, setIsOpenSearchDropdown] =
    useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dspFilter, setDspFilter] = useState<string[]>([]);

  const openDropdown = (): void => setIsOpenSearchDropdown(true);

  useOnClickOutside(dropdownRef, () => {
    if (isOpenSearchDropdown) {
      setIsOpenSearchDropdown(false);
    }
  });

  useEffect(() => {
    if (searchQuery.trim()?.length > 0) {
      searchPlaylists(searchQuery, dspFilter);
    }
  }, [searchQuery, dspFilter]);

  return (
    <Box
      position={isOpenSearchDropdown ? 'relative' : 'static'}
      margin={
        isSeparate ? '2rem auto' : isSmallScreen ? '1rem auto 0' : 'initial'
      }
      height={isOpenSearchDropdown ? '2.8rem' : 'auto'}
    >
      {!isOpenSearchDropdown && (
        <GreenButton onClick={openDropdown} type="button">
          <Span marginRight={3}>+</Span>
          <Span fontWeight={700}>Add a playlist</Span>
        </GreenButton>
      )}

      {isOpenSearchDropdown && (
        <Box
          ref={dropdownRef}
          backgroundColor={colors.White}
          position={isSmallScreen ? 'relative' : 'static'}
        >
          <SearchDropdown
            isSmallScreen={isSmallScreen}
            setSearchQuery={setSearchQuery}
            foundPlaylists={foundPlaylists}
            addedPlaylists={addedPlaylists}
            addPlaylistToUserList={addPlaylistToUserList}
            isSeparate={isSeparate}
            customers={customers}
            addingPlaylist={addingPlaylist}
            removingPlaylist={removingPlaylist}
            deletePlaylist={deletePlaylist}
            setDspFilter={setDspFilter}
          />
        </Box>
      )}
    </Box>
  );
};

const refetch: any = () => ({
  /** Search playlists for adding */
  searchPlaylists: (
    query: string,
    customerIds?: string[]
  ): { foundPlaylists: string } => {
    const customerFilter = customerIds ? `customerFilter=${customerIds}` : '';
    return {
      foundPlaylists: `/api/playlist?limit=999&nameFilter=${query}&playlistType=all&trackLimit=1&trackOffset=0&${customerFilter}`,
    };
  },
});

export default connect<any>(refetch)(Search as any);
